import { render, staticRenderFns } from "./Pep-statement-notification-table.vue?vue&type=template&id=e1de3972"
import script from "./Pep-statement-notification-table.vue?vue&type=script&lang=js"
export * from "./Pep-statement-notification-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports